import angular from 'angular';
import ChainSalesRankWidgetComponent from './chain-sales-rank-widget-component';

export default angular.module('chain-sales-rank-widget', []).component('chainSalesRankWidget', new ChainSalesRankWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/chain-sales-rank/chain-sales-rank-widget-module.js